import amqp from './amqp';
import crm from './crm';
import crmAgreementFile from './crm-agreement-file.js';
import crmAgreementPriceIncrease from './crm-agreement-price-increase';
import crmPartner from './crm-partner';
import basicPriceList from './basic-price-list';
import evidence from './evidence/index.js';
import invoiceDescriptionTemplates from './invoice-description-templates';
import invoiceNumberTemplate from './invoice-number-template.js';
import invoicePaymentDue from './invoice-payment-due.js';
import khTemplate from './kh-template.js';
import myAgreement from './my-agreement';
import pages from './pages.js';
import partnerStaff from './partner-staff';
import partnerStaffBoardMember from './partner-staff-board-member';
import staff from './staff';
import subscription from './subscription';
import systemBalance from './system-balance';
import systemRoles from './system-roles';
import systemTask from './system-task';
import zusDeclaration from './zus-declarations.js';
import zusDeclarationsPackage from './zus-declarations-package.js';
import zusPackage from './zus-package';
import zusWarning from './zus-warning';
import workParameters from './work-parameters.js';

export default [
  {
    path: '',
    component: () => import('../layouts/main/Main.vue'),
    children: [
      ...amqp,
      ...crm,
      ...crmAgreementFile,
      ...crmAgreementPriceIncrease,
      ...crmPartner,
      ...basicPriceList,
      ...evidence,
      ...invoiceDescriptionTemplates,
      ...invoiceNumberTemplate,
      ...invoicePaymentDue,
      ...khTemplate,
      ...myAgreement,
      ...partnerStaff,
      ...partnerStaffBoardMember,
      ...staff,
      ...subscription,
      ...systemBalance,
      ...systemRoles,
      ...systemTask,
      ...zusDeclaration,
      ...zusDeclarationsPackage,
      ...zusPackage,
      ...zusWarning,
      ...workParameters
    ],
  },
  ...pages,
];
